const userMediaCache: Map<string, MediaStream> = new Map();
export const getUserMedia = async (constraints: MediaStreamConstraints): Promise<MediaStream> => {
    if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
        throw new Error('getUserMedia is not supported in this browser');
    }
    const cachedStream = userMediaCache.get(JSON.stringify(constraints));
    if (cachedStream) {
        return cachedStream;
    }
    const stream = await navigator.mediaDevices.getUserMedia(constraints);
    userMediaCache.set(JSON.stringify(constraints), stream);
    return stream;
};

export const stopMediaStream = (stream: MediaStream): void => {
    stream.getTracks().forEach(track => track.stop());
    for (const [key, cachedStream] of userMediaCache.entries()) {
        if (cachedStream === stream) {
            userMediaCache.delete(key);
        }
    }
};

export const stopAllUserMedia = (): void => {
    for (const stream of userMediaCache.values()) {
        stream.getTracks().forEach(track => track.stop());
    }
    userMediaCache.clear();
};

